/**
 * NotFound - shown for any address that does not exist.
 */

import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { useI18n } from '../hooks/useI18n';

export default function NotFound() {
  const { t } = useI18n();
  return (
    <div className="container section text-center">
      <span className="feature-icon" style={{ margin: '0 auto var(--space-sm)' }}>
        <Compass size={28} aria-hidden="true" />
      </span>

      <h1>{t('notFound.title')}</h1>
      <p className="text-muted" style={{ maxWidth: '46ch', margin: 'var(--space-xs) auto var(--space-md)' }}>
        {t('notFound.body')}
      </p>

      <div className="hero-actions">
        <Link to="/" className="btn btn-primary btn-inline">
          {t('notFound.home')}
        </Link>
        <Link to="/marketplace" className="btn btn-outline btn-inline">
          {t('nav.browse')}
        </Link>
      </div>
    </div>
  );
}
